"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconPlusHeavy = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M35 64.64a5.34 5.34 0 0 1-5.34-5.34V10.7a5.34 5.34 0 1 1 10.68 0v48.6A5.34 5.34 0 0 1 35 64.64z"
  }), _react["default"].createElement("path", {
    d: "M59.3 40.34H10.7a5.34 5.34 0 1 1 0-10.68h48.6a5.34 5.34 0 1 1 0 10.68z"
  })),
  height: undefined,
  width: undefined
});
IconPlusHeavy.displayName = 'IconPlusHeavy';
var _default = IconPlusHeavy;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/plus-heavy.js
// module id = 127
// module chunks = 0